export default __webpack_public_path__ + "static/media/agricultural-4.8c8d4379.jpg";